export const environment = {
  production: true,
  portalapiurl: '__API_URL__',
  msal_ScopesAPI: '__API_SCOPE__',
  apiSignaturePreviewServer: '__OUTLOOK_ADDIN_URL__',
  msalSignaturePreviewScopes: '__OUTLOOK_ADDIN_SCOPE__',
  msal_clientID: '__CROSSWAREME_CLIENTID__',  
  rootUri: '__ROOT_URI__',
  postLogoutRedirectUri: '__ROOT_URI__/login',
  google_client_id: '__GOOGLE_CLIENT_ID__',
  appVersion: '__CWRELEASE__',
  redirectUri: '__ROOT_URI__/loginredirect',
  appInsights: {
    instrumentationKey: '',
  },
};
